import { useState, useEffect } from 'react';
import { useClaudeConfig } from './useClaudeConfig';
import { parseFrontmatter, serializeFrontmatter } from './frontmatter';

export function useFrontmatterEditor(filePath: string) {
  const config = useClaudeConfig(filePath);
  const [attrs, setAttrs] = useState<Record<string, unknown>>({});
  const [body, setBody] = useState('');

  useEffect(() => {
    if (config.content) {
      const parsed = parseFrontmatter(config.content);
      setAttrs(parsed.attributes);
      setBody(parsed.body);
    } else {
      setAttrs({});
      setBody('');
    }
  }, [config.content]);

  function updateAttr(key: string, value: unknown) {
    const next = { ...attrs, [key]: value };
    setAttrs(next);
    config.setContent(serializeFrontmatter(next, body));
  }

  function updateBody(newBody: string) {
    setBody(newBody);
    config.setContent(serializeFrontmatter(attrs, newBody));
  }

  function resetContent(newAttrs: Record<string, unknown>, newBody: string) {
    setAttrs(newAttrs);
    setBody(newBody);
    config.setContent(serializeFrontmatter(newAttrs, newBody));
  }

  function clear() {
    setAttrs({});
    setBody('');
  }

  return { attrs, body, updateAttr, updateBody, resetContent, clear, config };
}
